import img1 from "../img/portfolios/Technician.png";
import img2 from "../img/portfolios/Caloriestracker.png";

const portfolios = [
  {
    id: 1,
    category: "AI / SaaS",
    catagory: "AI / SaaS",
    image: "https://images.unsplash.com/photo-1556740738-b6a63e27c4df?w=600&h=400&fit=crop",
    link1: "https://github.com/thakuryash",
    link2: "https://carworthai.ca/",
    title: "CarWorthAI",
    text: "AI-powered vehicle valuation platform that helps users estimate market value with a modern and intuitive experience.",
    isFeatured: true,
    status: "Live",
    techStack: ["React", "TypeScript", "Node.js", "AI APIs"],
    highlights: ["Live production launch at carworthai.ca", "VIN-first valuation workflow", "Optimized UX for mobile and desktop"],
  },
  {
    id: 2,
    category: "React",
    catagory: "React",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&h=400&fit=crop",
    link1: "https://github.com/thakuryash",
    link2: "https://thakuryash.github.io/",
    title: "Portfolio Website",
    text: "Modern React portfolio with animations and responsive design",
    status: "Live",
    techStack: ["React", "Framer Motion", "Styled Components"],
  },
  {
    id: 3,
    category: "Full Stack",
    catagory: "Full Stack",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&h=400&fit=crop",
    link1: "https://github.com/thakuryash",
    link2: "#",
    title: "Data Tracing System",
    text: "Cloud-based system for Greentronic using React, .NET, and Azure",
    status: "Enterprise",
    techStack: ["React", ".NET", "Azure"],
  },
  {
    id: 4,
    category: "React",
    catagory: "React",
    image: "https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?w=600&h=400&fit=crop",
    link1: "https://github.com/thakuryash",
    link2: "#",
    title: "Automotive Platform",
    text: "Customized dealership websites for 300+ clients at Cox Automotive",
    status: "Production",
    techStack: ["React", "A/B Testing", "Performance Optimization"],
  },
  {
    id: 5,
    category: "JavaScript",
    catagory: "JavaScript",
    image: img2,
    link1: "https://github.com/thakuryash/Tracalorie",
    link2: "https://thakuryash.github.io/Tracalorie/",
    title: "Calories Tracker",
    text: "Track your daily calorie intake with local storage",
    status: "Live",
    techStack: ["JavaScript", "LocalStorage", "Bootstrap"],
  },
  {
    id: 6,
    category: "JavaScript",
    catagory: "JavaScript",
    image: img1,
    link1: "https://github.com/thakuryash/Portfolio",
    link2: "https://thakuryash.github.io/Portfolio/",
    title: "Previous Portfolio",
    text: "My mechanical background portfolio showcase",
    status: "Archived",
    techStack: ["JavaScript", "HTML", "CSS"],
  },
  {
    id: 7,
    category: "Cloud",
    catagory: "Cloud",
    image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&h=400&fit=crop",
    link1: "https://github.com/thakuryash",
    link2: "#",
    title: "Azure Cloud Solutions",
    text: "Native cloud applications with optimized performance",
    status: "Consulting",
    techStack: ["Azure", "C#", "Cloud Architecture"],
  },
];

export default portfolios;
